<template>
    <div class="help-center-page">
        <!-- 页面头部 -->
        <div class="help-center-page__header">
            <div class="help-center-page__header-left">
                <div class="help-center-page__title">企业消费充值日志</div>
                <div class="help-center-page__subtitle">共 {{ total }} 条记录</div>
            </div>
            <div class="help-center-page__header-right">
                <button class="help-center-refresh-btn" @click="refresh">
                    <i class="el-icon-refresh"></i> 更新最新数据
                </button>
            </div>
        </div>

        <!-- 内容卡片 -->
        <div class="help-center-content-card">
            <!-- 筛选区域 -->
            <div class="help-center-section help-center-section--filter">
                <div class="help-center-section__title">筛选条件</div>
                <div class="help-center-filter-row">
                    <div class="help-center-filter-item">
                        <label class="help-center-filter-label">类型</label>
                        <el-select filterable v-model="listQuery.Type" size="small" class="help-center-select" placeholder="全部">
                            <el-option v-for="item in typeArr" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="help-center-filter-item">
                        <label class="help-center-filter-label">选择时间</label>
                        <el-date-picker
                            v-model="searchDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            class="help-center-date-picker"
                        >
                        </el-date-picker>
                    </div>
                    <div class="help-center-filter-item help-center-filter-item--actions">
                        <button class="help-center-search-btn help-center-search-btn--ghost" @click="reset">重置</button>
                        <button class="help-center-search-btn" @click="getList">查找</button>
                    </div>
                </div>
            </div>

            <!-- 报表数据区域 -->
            <div class="help-center-section help-center-section--report">
                <div class="help-center-section__title">消费明细</div>

                <!-- 表格区域 -->
                <div class="help-center-table-wrap tableAuto">
                    <div class="tableAutoMain">
                        <el-table
                            ref="Table1"
                            :data="KhList"
                            style="width: 100%"
                            height="calc(100% - 0.1rem)"
                            v-if="KhList.length > 0"
                        >
                            <el-table-column align="center" show-overflow-tooltip label="企业ID" width="120" fixed>
                                <template slot-scope="scope">{{ scope.row.EnterpriseId }}</template>
                            </el-table-column>

                            <el-table-column align="left" show-overflow-tooltip label="企业名" min-width="200">
                                <template slot-scope="scope">
                                    <div class="help-center-enterprise-cell">
                                        <span class="help-center-avatar-icon" :style="{ background: getAvatarColor(scope.row.EnterpriseName) }">
                                            {{ scope.row.EnterpriseName ? scope.row.EnterpriseName.charAt(0).toUpperCase() : '?' }}
                                        </span>
                                        <span class="help-center-enterprise-name">{{ scope.row.EnterpriseName }}</span>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="类型" width="100">
                                <template slot-scope="scope">
                                    <span class="help-center-type-badge" :class="getTypeClass(scope.row.Type)">
                                        {{ scope.row.Type === 0 ? '话费充值' : scope.row.Type === 1 ? '话费套餐' : '用户系统费' }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="当前余额/额度" width="130">
                                <template slot-scope="scope">{{ scope.row.Money }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="上次余额/额度" width="130">
                                <template slot-scope="scope">{{ scope.row.LastMoney }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="创建时间" min-width="170">
                                <template slot-scope="scope">{{ scope.row.PassCreatime | formaDate('yyyy-MM-dd hh:mm:ss') }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="备注" min-width="180" fixed="right">
                                <template slot-scope="scope">{{ scope.row.Remark }}</template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="help-center-empty">
                            <i class="el-icon-document"></i>
                            <p>暂无消费数据</p>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="help-center-pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="listQuery.PageIndex"
                        :page-size="listQuery.PageSize"
                        :page-sizes="[10, 20, 50]"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetEnterpriseExpenseInfoPageList, UpdateEnterpriseOrSeatInfo } from '@/api/LogOrReport';

export default {
    components: {},
    data() {
        return {
            typeArr: [
                { value: 0, name: '话费充值' },
                { value: 1, name: '话费套餐' },
                { value: 2, name: '用户系统费' }
            ],
            searchDate: null,
            listQuery: {},
            KhList: [],
            total: 0,
            listLoading: true,
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.pickerOneDate = minDate.getTime();
                    if (maxDate) {
                        this.pickerOneDate = '';
                    }
                },
                disabledDate: (time) => {
                    if (this.pickerOneDate) {
                        const day = 30 * 24 * 3600 * 1000;
                        let maxTime = this.pickerOneDate + day;
                        let minTime = this.pickerOneDate - day;
                        return time.getTime() > maxTime || time.getTime() < minTime;
                    }
                }
            }
        };
    },
    created() {
        let rootDate = new Date().toLocaleDateString();
        let StartTime = this.$options.filters['formaDate'](new Date(rootDate), 'yyyy-MM-dd');
        let EndTime = this.$options.filters['formaDate'](new Date(rootDate), 'yyyy-MM-dd');
        this.searchDate = [StartTime, EndTime];
        this.listQuery = {
            PageIndex: 1,
            PageSize: 10
        };
        this.getList();
    },
    methods: {
        getAvatarColor(name) {
            const colors = ['#007aff', '#34c759', '#ff9500', '#ff3b30', '#af52de', '#5856d6', '#ff2d55', '#64d2ff'];
            let hash = 0;
            for (let i = 0; i < (name || '').length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            return colors[Math.abs(hash) % colors.length];
        },
        getTypeClass(type) {
            if (type === 0) return 'help-center-type-badge--blue';
            if (type === 1) return 'help-center-type-badge--green';
            return 'help-center-type-badge--orange';
        },
        refresh() {
            UpdateEnterpriseOrSeatInfo({})
                .then((res) => {
                    this.$alert(res.data.Message, '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            this.getList();
                        }
                    });
                })
                .catch(() => {});
        },
        reset() {
            let rootDate = new Date().toLocaleDateString();
            let StartTime = this.$options.filters['formaDate'](new Date(rootDate), 'yyyy-MM-dd');
            let EndTime = this.$options.filters['formaDate'](new Date(rootDate), 'yyyy-MM-dd');
            this.searchDate = [StartTime, EndTime];
            this.listQuery = {
                PageIndex: 1,
                PageSize: 10
            };
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.PageIndex = 1;
            this.listQuery['PageSize'] = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.PageIndex = val;
            this.getList();
        },
        getList() {
            this.listLoading = true;
            if (this.searchDate) {
                this.listQuery.StartTime = this.searchDate[0] + ' 00:00:00';
                this.listQuery.EndTime = this.searchDate[1] + ' 23:59:59';
            } else {
                this.$alert('请选择创建时间', '', {
                    confirmButtonText: '确定',
                    callback: () => {}
                });
                return;
            }
            GetEnterpriseExpenseInfoPageList(this.listQuery)
                .then((res) => {
                    this.listLoading = false;
                    this.KhList = res.data.Data;
                    this.total = res.data.Total;
                })
                .catch(() => {
                    this.listLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
/* ===========================
   企业消费充值日志 - Apple Mac 风格
   =========================== */
.help-center-page {
    background: #f5f5f7;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 16px;
}

/* 页面头部 */
.help-center-page__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 8px;
    flex-shrink: 0;
    background: transparent;
}

.help-center-page__header-left {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
}

.help-center-page__title {
    font-size: 20px;
    font-weight: 700;
    color: #1d1d1f;
    line-height: 1.2;
}

.help-center-page__subtitle {
    font-size: 11px;
    color: #86868b;
}

.help-center-page__header-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* 刷新按钮 */
.help-center-refresh-btn {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    background: #007aff;
    border: none;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 122, 255, 0.35);
    transition: background 0.15s, transform 0.1s;
    white-space: nowrap;

    &:hover {
        background: #0071e3;
    }

    &:active {
        transform: scale(0.97);
    }
}

/* 白色大卡片 */
.help-center-content-card {
    flex: 1;
    min-height: 0;
    margin: 8px 20px 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 通用区域 */
.help-center-section {
    padding: 0;
}

.help-center-section--filter {
    flex-shrink: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
}

.help-center-section--report {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.help-center-section__title {
    font-size: 14px;
    font-weight: 600;
    color: #1d1d1f;
    padding: 12px 16px 8px;
}

/* 筛选区域 */
.help-center-filter-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    padding: 4px 16px 12px;
    flex-wrap: wrap;
}

.help-center-filter-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.help-center-filter-label {
    font-size: 10px;
    font-weight: 600;
    color: #86868b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.help-center-filter-item--actions {
    flex-direction: row;
    align-items: flex-end;
    gap: 6px;
    padding-top: 16px;
}

::v-deep .help-center-date-picker {
    width: 260px;
    .el-input__inner {
        border-radius: 8px;
        border: 1.5px solid rgba(0, 0, 0, 0.1);
        background: #fff;
        height: 34px;
        line-height: 34px;
        font-size: 12px;
        transition: border-color 0.15s, box-shadow 0.15s;
        &:focus {
            border-color: #007aff;
            box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.1);
        }
    }
}

::v-deep .help-center-select {
    width: 140px;
    .el-input__inner {
        border-radius: 8px;
        border: 1.5px solid rgba(0, 0, 0, 0.1);
        background: #fff;
        height: 34px;
        line-height: 34px;
        font-size: 12px;
        transition: border-color 0.15s, box-shadow 0.15s;
        &:focus {
            border-color: #007aff;
            box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.1);
        }
    }
}

/* 搜索按钮 */
.help-center-search-btn {
    padding: 7px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.05);
    color: #3c3c43;
    transition: background 0.15s;
    white-space: nowrap;

    &:hover {
        background: rgba(0, 0, 0, 0.09);
    }

    &--ghost {
        background: rgba(0, 0, 0, 0.05);
        color: #3c3c43;

        &:hover {
            background: rgba(0, 0, 0, 0.09);
        }
    }

    &:last-child {
        background: #007aff;
        color: #fff;

        &:hover {
            background: #0071e3;
        }
    }
}

/* 表格区域 */
.help-center-table-wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    background: #f5f5f7;
}

::v-deep .help-center-table-wrap .el-table {
    background: transparent;

    &::before {
        display: none;
    }

    /* 表头 */
    .el-table__header-wrapper {
        background: #f5f5f7 !important;
    }

    .el-table__header tr {
        background: transparent !important;
    }

    thead th {
        background: #f5f5f7 !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
        padding: 4px 0;
    }

    thead th .cell {
        background: transparent !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
    }

    /* 固定列 */
    .el-table__fixed {
        thead th {
            background: #f5f5f7 !important;
        }

        &::before {
            display: none !important;
        }

        tbody td {
            background: #fff !important;
            border-bottom: 8px solid #f5f5f7 !important;
            box-shadow: none !important;
        }
    }

    .el-table__fixed-right {
        thead th {
            background: #f5f5f7 !important;
        }

        &::before {
            display: none !important;
        }

        .el-table__fixed-header-wrapper {
            background: #f5f5f7 !important;
        }

        tbody td {
            background: #fff !important;
            border-bottom: 8px solid #f5f5f7 !important;
            box-shadow: none !important;
        }
    }

    .el-table__fixed-right-patch {
        background: #f5f5f7 !important;
    }

    /* 数据行卡片化 */
    .el-table__body {
        border-collapse: collapse;
        width: 100% !important;
    }

    tbody tr {
        background: transparent !important;
    }

    tbody td {
        background: #fff !important;
        font-size: 13px;
        color: #1d1d1f;
        padding: 8px 0 !important;
        border-bottom: 8px solid #f5f5f7 !important;
        border-top: none !important;
        border-right: none !important;
        transition: background 0.15s;
    }

    tbody td .cell {
        font-size: 13px;
    }

    tbody tr td:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    tbody tr td:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    tr:hover td {
        background: #fff !important;
    }
}

/* 企业名列 */
.help-center-enterprise-cell {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding-left: 8px;
}

.help-center-avatar-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    line-height: 1;
}

.help-center-enterprise-name {
    font-size: 12px;
    font-weight: 600;
    color: #1d1d1f;
    line-height: 1.2;
}

/* 类型徽章 */
.help-center-type-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    line-height: 1.4;
    white-space: nowrap;

    &--blue {
        background: #007aff;
    }

    &--green {
        background: #34c759;
    }

    &--orange {
        background: #ff9500;
    }
}

/* 空状态 */
.help-center-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #86868b;

    i {
        font-size: 48px;
        margin-bottom: 12px;
        opacity: 0.4;
    }

    p {
        font-size: 13px;
    }
}

/* 分页器 */
.help-center-pagination {
    padding: 14px 20px;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
}
</style>
